import React from 'react';
import PropTypes from 'prop-types';
import * as C from '../../models/materials/constants';
import Materials from './Material';
import News from './News';

function isMainMaterial(tags) {
    let find = false;
    tags.forEach((item) => {
        if (item._id === 'olimpic2018-main-material') {
            find = true;
        }
    });
    return find;
}

function getMaterialsWithoutMain(materials) {
    const resultMaterials = [];
    materials.forEach((item) => {
        if (!isMainMaterial(item.privateTags)) {
            resultMaterials.push(item);
        }
    });
    return resultMaterials;
}


export default class MaterialSection extends React.Component {
    static propTypes = {
        // eslint-disable-next-line
        answer: PropTypes.any,
        // eslint-disable-next-line
        actions: PropTypes.any,
        // eslint-disable-next-line
        mlimits: PropTypes.any.isRequired,
        // eslint-disable-next-line
        nlimits: PropTypes.any.isRequired,
        // eslint-disable-next-line
        button: PropTypes.any,
        // eslint-disable-next-line
        fullpage: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.state = {
            news: [],
            materials: [],
            loading: false,
            currentPage: -1
        };
        this.clickHander = this.clickHander.bind(this);
    }

    componentDidMount() {
        this.props.actions.loadMaterials((window.location.pathname.indexOf('materials') + 1 === 0) ? 100 : this.props.mlimits, 0);
        this.props.actions.loadNews((window.location.pathname.indexOf('materials') + 1 === 0) ? 100 : this.props.nlimits, 0);
    }

    componentWillReceiveProps(props) {
        if (props.answer && props.answer.state) {
            if (this.state.currentPage >= 0) {
                if (props.answer.state === C.FINISH_LOAD_MATERIALS) {
                    this.setState({
                        materials: [...this.state.materials, ...props.answer.data],
                        loading: false
                    });
                }
                if (props.answer.state === C.FINISH_LOAD_NEWS) {
                    this.setState({
                        news: [...this.state.materials, ...props.answer.data],
                        loading: false
                    });
                }
            } else {
                if (props.answer.state === C.FINISH_LOAD_MATERIALS) {
                    this.setState({
                        materials: props.answer.data,
                        loading: false
                    });
                }
                if (props.answer.state === C.FINISH_LOAD_NEWS) {
                    this.setState({
                        news: props.answer.data,
                        loading: false
                    });
                }
            }
        }
    }

    clickHander() {
        if (this.state.loading === false) {
            const page = this.state.currentPage + 1;
            this.setState({
                loading: true,
                currentPage: page
            });
            this.props.actions.loadMaterials(this.props.mlimits - 1, page);
            this.props.actions.loadNews(this.props.nlimits, page);
        }
    }

    render() {
        const materials = (this.state.currentPage === -1 && window.location.pathname.indexOf('materials') + 1 === 0) ?
            getMaterialsWithoutMain(this.state.materials).splice(0, this.props.mlimits)
            : this.state.materials;
        const news = (this.state.currentPage === -1 && window.location.pathname.indexOf('materials') + 1 === 0) ?
            getMaterialsWithoutMain(this.state.news).splice(0, this.props.nlimits)
            : this.state.news;
        return (
            <React.Fragment>
                <div className="materials">
                    <Materials data={materials} />
                    <News data={news} />
                </div> 
                {this.props.button !== undefined && this.state.loading === false
                    ? <div className="materials__button">
                        <button className="button button_big" onClick={this.clickHander}>
                            <span className="button__text">{this.props.button.text}</span>
                        </button>
                    </div> 
                    : null
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Materials/Index.jsx